'use strict';

const libOSD = require('pict-section-openseadragon');

/**
 * PictView-MediaViewer
 * --------------------
 * A full-page deep-zoom viewer for a single screenshot. Extends pict-section-openseadragon
 * in its no-annotation mode ({ Annotorious: false } -- the opt-out flag we added to that
 * module), so it needs only the OpenSeaDragon global, not the Annotorious stack. A plain
 * image tile source points at the media blob; OpenSeaDragon supplies smooth deep zoom and
 * pan. Reached via #/media/:id, and from the "Open viewer" link in the quick-view lightbox.
 */
class PlansheetMediaViewer extends libOSD
{
	// Paint the full-page shell (bar + controls + OSD host), point the viewer at the media blob, mount OSD.
	show(pID)
	{
		this._id = parseInt(pID, 10) || 0;
		if (!this._id) { return; }
		let tmpURL = '/1.0/Media/' + this._id + '/Blob';
		let tmpV = "_Pict.views['Plansheet-MediaViewer']";
		let tmpShell =
			'<div class="ps-osd-page">'
			+ '<div class="ps-osd-bar">'
				+ '<button type="button" class="ps-osd-btn" onclick="window.history.back()">&larr; Back</button>'
				+ '<span class="ps-osd-title">Screenshot &mdash; deep zoom</span>'
				+ '<button type="button" class="ps-osd-btn" title="Zoom out" onclick="' + tmpV + '.osdZoom(0.7)">&minus;</button>'
				+ '<button type="button" class="ps-osd-btn" title="Zoom in" onclick="' + tmpV + '.osdZoom(1.5)">+</button>'
				+ '<button type="button" class="ps-osd-btn" title="Fit to screen" onclick="' + tmpV + '.osdHome()">Fit</button>'
				+ '<button type="button" class="ps-osd-btn" title="Fullscreen" onclick="' + tmpV + '.osdFullscreen()">Fullscreen</button>'
				+ '<a class="ps-osd-btn" href="' + tmpURL + '" download>Download</a>'
			+ '</div>'
			+ '<div id="OpenSeaDragon-Container-Div" class="ps-osd-stage"></div>'
			+ '</div>';
		this.pict.ContentAssignment.assignContent('#Plansheet-Workspace', tmpShell);
		// A plain single image (no DZI tiling needed); OpenSeaDragon still gives full smooth zoom.
		this.options.TileSources = { type: 'image', url: tmpURL };
		this.render();
	}

	// Called by the base view just before it builds the OpenSeaDragon instance; tune it for deep zoom.
	customConfigureViewerSettings()
	{
		// Let the user zoom well past native resolution for a real deep-zoom feel on a screenshot.
		this.osdSettings.maxZoomPixelRatio = 8;
		this.osdSettings.minZoomImageRatio = 0.7;
		this.osdSettings.visibilityRatio = 1;
	}

	osdZoom(pFactor) { if (this.viewer) { this.viewer.viewport.zoomBy(pFactor); this.viewer.viewport.applyConstraints(); } }
	osdHome() { if (this.viewer) { this.viewer.viewport.goHome(); } }
	osdFullscreen() { if (this.viewer && typeof this.viewer.setFullScreen === 'function') { this.viewer.setFullScreen(true); } }
}

module.exports = PlansheetMediaViewer;
module.exports.default_configuration = Object.assign({}, libOSD.default_configuration,
{
	ViewIdentifier: 'Plansheet-MediaViewer',
	ViewAddress: 'Plansheet-MediaViewer',
	RenderOnLoad: false,
	AutoRender: false,
	// The opt-out flag: run OpenSeaDragon with no annotation layer (no Annotorious globals needed).
	Annotorious: false,
	// We supply our own styled controls in the bar, so hide OpenSeaDragon's default button set.
	DisableButtons: true,
	DisableFullscreen: true,
	PrefixUrl: '/openseadragon-images/',
	CSS: /*css*/`
		.ps-osd-page { display: flex; flex-direction: column; height: calc(100vh - 130px); min-height: 420px; }
		.ps-osd-bar { display: flex; align-items: center; gap: 8px; padding: 6px 2px 12px; flex-wrap: wrap; }
		.ps-osd-btn { font: inherit; font-size: 13px; padding: 6px 12px; border-radius: 7px; border: 1px solid var(--theme-color-border-default, #d8dde6); background: transparent; color: inherit; cursor: pointer; text-decoration: none; white-space: nowrap; }
		.ps-osd-btn:hover { border-color: var(--theme-color-brand-primary, #f0c44a); color: var(--theme-color-brand-primary, #f0c44a); }
		.ps-osd-title { font-family: ui-monospace, Menlo, monospace; font-size: 12px; letter-spacing: 1.6px; text-transform: uppercase; color: var(--theme-color-text-secondary, #7a8699); margin-right: auto; }
		.ps-osd-stage { flex: 1 1 auto; min-height: 0; background: #0b1420; border: 1px solid var(--theme-color-border-default, #d8dde6); border-radius: 8px; overflow: hidden; }
		.ps-osd-stage #OSD-Containers-Wrapper, .ps-osd-stage #OpenSeaDragon-Element, .ps-osd-stage .osd-default { width: 100%; height: 100%; }
	`
});
